import * as CatUtil from '../CatUtil';

export function getAdminRoutes() {
  const about = CatUtil.getCategoryInstance('about');

  return [
    {name: '首頁', path: '/admin/'},
    {name: '重設密碼', path: 'reset-password', key: 'reset-password'},
    {
      name: '最新消息',
      path: '__group-article',
      key: 'news',
      subroutes: [
        {
          name: '消息類別分類',
          path: `/admin/article_category/?action=detail&id=${
            CatUtil.getCategoryInstance('article_category')?.id
          }`,
        },
        {name: '最新消息清單', path: '/admin/articles/'},
        {
          name: '過期消息清單',
          path: '/admin/articles/expired',
        },
      ],
    },
    {
      name: '衛教專區管理',
      path: '__group-health-education',
      key: 'health-education',
      subroutes: [
        {
          name: '衛教專區類別設定',
          path: `/admin/health_education_category/?action=detail&id=${
            CatUtil.getCategoryInstance('health_education_category')?.id
          }`,
        },
        {name: '衛教專區清單', path: '/admin/health_educations/'},
      ],
    },
    {name: '活動花絮', path: '/admin/activities/', key: 'activity'},

    {
      name: '檔案下載',
      path: '__group-download',
      key: 'download',
      subroutes: [
        {
          name: '檔案下載類別設定',
          path: `/admin/download_category/?action=detail&id=${
            CatUtil.getCategoryInstance('download_category')?.id
          }`,
        },
        {name: '檔案下載清單', path: '/admin/downloads/'},
      ],
    },
    {name: '診所查詢地圖', path: '/admin/clinics/', key: 'clinic'},
    {
      name: '會員管理',
      path: '__group-members',
      key: 'user',
      subroutes: [
        {name: '會員清單管理', path: '/admin/users/'},
        {name: '新入會申請', path: '/admin/pending_registrations/'},
        {name: '資料異動申請', path: '/admin/revisions/'},
        // {name: '進修時數紀錄', path: '/admin/study_hours/'},
        // {name: '常費繳納紀錄', path: '/admin/member_fees/'},
      ],
    },

    {
      name: '活動',
      path: '__group-product',
      key: 'product',
      subroutes: [
        {
          name: '活動分類',
          path: `/admin/product_category/?action=detail&id=${
            CatUtil.getCategoryInstance('product_category')?.id
          }`,
        },
        {name: '活動總覽', path: '/admin/products/'},
        {name: '報名處理作業', path: '/admin/event-products/'},
        {name: '刷卡紀錄', path: '/admin/credit_card_statement/'},
      ],
    },

    {name: '線上問卷', path: '/admin/questionnaire/', key: 'questionnaire'},
    {
      name: '電子報',
      path: '__group-newsletters',
      key: 'newsletter',
      subroutes: [
        {name: '電子報維護', path: '/admin/newsletters/'},
        {name: '訂戶名單維護', path: '/admin/newsletter_subscriptions/'},
      ],
    },

    {
      name: '公會介紹管理',
      path: '__group-about',
      key: 'about',
      subroutes: [
        {
          name: '本會簡介',
          path: `/admin/about/introduction?action=detail&id=${about?.id}`,
        },
        {
          name: '理事長的話',
          path: `/admin/about/chairman?action=detail&id=${about?.id}`,
        },
        {
          name: '歷屆理事長',
          path: `/admin/about/previous_chairman?action=detail&id=${about?.id}`,
        },
        {
          name: '理監事組織表',
          path: `/admin/about/org_chart?action=detail&id=${about?.id}`,
        },
        {
          name: '公會聯絡資訊',
          path: `/admin/about/information?action=detail&id=${about?.id}`,
        },
      ],
    },

    {
      name: '通知信件模板',
      path: '/admin/email_templates',
      key: 'email-template',
    },

    {
      name: '系統維護',
      path: '__group-system',
      key: 'system',
      subroutes: [
        {name: '系統使用紀錄', path: '/admin/admin_usage_history/'},
        {name: '會員使用紀錄', path: '/admin/user_login_history/'},
        {name: '使用者維護', path: '/admin/admin-users/'},
      ],
    },
    // {
    //   name: '官網管理(棄用)',
    //   path: '__group-website',
    //   subroutes: [
    //     {name: '最新消息', path: '/admin/internal_news/'},
    //     {name: '活動花絮', path: '/admin/activities/'},
    //     {name: '徵才看板', path: '/admin/jobs/'},
    //     {name: '專題講義', path: '/admin/speech_keynotes/'},
    //     {name: '行政文件', path: '/admin/admin_documents/'},
    //     {name: '訴代專區', path: '/admin/law_services/'},
    //     {name: '專業榜', path: '/admin/honors/'},
    //     {name: '季刊', path: '/admin/magazines/'},
    //     {name: '美國電子報', path: '/admin/us_magazines/'},
    //     {name: '會議記錄', path: '/admin/meetings/'},
    //     {name: '財務報表', path: '/admin/financial_reports/'},
    //     {name: '職前訓練', path: '/admin/trainings/'},
    //     {name: '社會參與', path: '/admin/social_participations/'},
    //     {name: '理監事', path: '/admin/supervisors/'},
    //     {name: '理監事成員', path: '/admin/supervisor_members/'},
    //     {name: '委員會', path: '/admin/committees/'},
    //     {name: '委員會成員', path: '/admin/committee_members/'},
    //     {name: '委員會申請', path: '/admin/committee_member_applications/'},
    //     {name: '公會組織圖', path: '/admin/org_charts/'},
    //     {name: '診所', path: '/admin/clinics/'},
    //   ],
    // },
    {name: '網站設定', path: '/admin/site/', key: 'site'},
    // {name: '頁面', path: '/admin/pages'},
    {name: '推播', path: '/admin/push_notifications', key: 'push-notification'},
    // {
    //   name: '兌換獎品',
    //   path: '/admin/rewards',
    // },
    // {
    //   name: '討論區',
    //   path: '/admin/posts',
    // },
    // {name: '前台手動更新', path: '/admin/rebuild-history'},
    // {
    //   name: '上傳工具',
    //   path: '__group-uploader',
    //   subroutes: [
    //     {name: '圖片上傳', path: 'image-uploader'},
    //     {name: '檔案上傳', path: 'file-uploader'},
    //   ],
    // },

    {name: '登出', path: 'logout'},
  ];
}
